<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-clip-rotate-multiple" [fullScreen]="true">
    <p style="font-size: 18px; color: white">Loading...</p>
</ngx-spinner>